import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { use as _$use } from "solid-js/web";
import { spread as _$spread } from "solid-js/web";
import { mergeProps as _$mergeProps } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<span class=err>✗ `),
  _tmpl$2 = /*#__PURE__*/_$template(`<span class=tzr-bulk-counts><span class=ok>✓ `),
  _tmpl$3 = /*#__PURE__*/_$template(`<h3> (<!>)`),
  _tmpl$4 = /*#__PURE__*/_$template(`<div class=tzr-overlay><div class="tzr-window bulk"><header><span></span><span class=tzr-x>✕</span></header><main><div class=tzr-bulk-body><div class=tzr-bulk-shared><h3></h3><label class=tzr-field><span></span><input></label><div class=tzr-field><span></span><div class=tzr-tiles></div></div><div class=tzr-hint></div></div><div class="tzr-dropzone compact"><input type=file multiple style=display:none><div class=tzr-drop-icon>🗂</div><div></div></div><div class=tzr-bulk-list><h3> (<!>)</h3></div></div></main><footer><div><button type=button class=tzr-btn></button></div><div><button type=button class="tzr-btn primary"> (<!>)`),
  _tmpl$5 = /*#__PURE__*/_$template(`<div class="tzr-tile small">`),
  _tmpl$6 = /*#__PURE__*/_$template(`<div class=tzr-hint>`),
  _tmpl$7 = /*#__PURE__*/_$template(`<span class="tzr-pill warn">⚠ `),
  _tmpl$8 = /*#__PURE__*/_$template(`<div class=tzr-bulk-error>✗ `),
  _tmpl$9 = /*#__PURE__*/_$template(`<div class=tzr-bulk-row><span class=tzr-bulk-name></span><span class=tzr-bulk-status>`),
  _tmpl$0 = /*#__PURE__*/_$template(`<div class="tzr-bulk-row unmatched"><span class=tzr-bulk-name></span><span class=tzr-bulk-status>`);
/**
 * Bulk import overlay: drop many photo+txt files, pairs match by file name; shared values
 * (locality, measurement context) prefill every created DRAFT. Runs sequentially with a
 * per-pair status row and a success/error summary; failed pairs can be retried.
 */

import { For, Show } from 'solid-js';
import { useWorkflow } from 'mmodSolidWorkflow';
import { MEASUREMENT_CONTEXTS } from './constants';
import { useDropzone } from './components';
export function BulkImport() {
  const {
    store,
    module: m,
    t,
    tr
  } = useWorkflow();
  const b = () => store.bulk;
  let elPicker;
  const onPicked = () => {
    const files = Array.from(elPicker.files); // snapshot — the live FileList empties on reset
    elPicker.value = '';
    m.bulkTakeFiles(files);
  };
  const drop = useDropzone(files => m.bulkTakeFiles(files));
  const pairs = () => m.bulkPairs().pairs;
  const unmatched = () => m.bulkPairs().unmatched;
  const result = key => b().results[key];
  const counts = () => {
    const all = Object.values(b().results);
    return {
      ok: all.filter(r => r.status === 'ok').length,
      error: all.filter(r => r.status === 'error').length
    };
  };
  const importable = () => pairs().some(pair => {
    var _result;
    return !/^(ok|exists)$/.test((_result = result(pair.key)) === null || _result === void 0 ? void 0 : _result.status);
  });
  return (() => {
    var _el$ = _tmpl$4(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.firstChild,
      _el$5 = _el$4.nextSibling,
      _el$6 = _el$3.nextSibling,
      _el$7 = _el$6.firstChild,
      _el$8 = _el$7.firstChild,
      _el$9 = _el$8.firstChild,
      _el$0 = _el$9.nextSibling,
      _el$1 = _el$0.firstChild,
      _el$10 = _el$1.nextSibling,
      _el$11 = _el$0.nextSibling,
      _el$12 = _el$11.firstChild,
      _el$13 = _el$12.nextSibling,
      _el$14 = _el$11.nextSibling,
      _el$15 = _el$8.nextSibling,
      _el$16 = _el$15.firstChild,
      _el$17 = _el$16.nextSibling,
      _el$18 = _el$17.nextSibling,
      _el$19 = _el$15.nextSibling,
      _el$20 = _el$19.firstChild,
      _el$21 = _el$20.firstChild,
      _el$28 = _el$21.nextSibling,
      _el$22 = _el$28.nextSibling,
      _el$33 = _el$6.nextSibling,
      _el$34 = _el$33.firstChild,
      _el$35 = _el$34.firstChild,
      _el$36 = _el$34.nextSibling,
      _el$37 = _el$36.firstChild,
      _el$38 = _el$37.firstChild,
      _el$40 = _el$38.nextSibling,
      _el$39 = _el$40.nextSibling;
    _$insert(_el$4, () => tr('bulk.Title'));
    _el$5.$$click = () => m.closeBulk();
    _$insert(_el$9, () => tr('bulk.Shared'));
    _$insert(_el$1, () => tr('locality'));
    _el$10.$$input = e => m.setStore('bulk', 'shared', 'locality', e.currentTarget.value);
    _$insert(_el$12, () => tr('context'));
    _$insert(_el$13, _$createComponent(For, {
      each: MEASUREMENT_CONTEXTS,
      children: key => (() => {
        var _el$41 = _tmpl$5();
        _el$41.$$click = () => {
          if (!b().running) m.setStore('bulk', 'shared', 'context', b().shared.context === key ? '' : key);
        };
        _$insert(_el$41, () => t(`delict.context.${key}`));
        _$effect(() => _el$41.classList.toggle("sel", !!(b().shared.context === key)));
        return _el$41;
      })()
    }));
    _$insert(_el$14, () => tr('bulk.SharedHint'));
    _el$15.$$click = () => {
      var _elPicker;
      if (!b().running) (_elPicker = elPicker) === null || _elPicker === void 0 ? void 0 : _elPicker.click();
    };
    _$spread(_el$15, _$mergeProps({
      get classList() {
        return {
          dragging: drop.dragging()
        };
      }
    }, () => drop.handlers), false, true);
    _el$16.addEventListener("change", onPicked);
    var _ref$ = elPicker;
    typeof _ref$ === "function" ? _$use(_ref$, _el$16) : elPicker = _el$16;
    _$insert(_el$18, () => tr('bulk.Drop'));
    _$insert(_el$20, () => tr('bulk.Pairs'), _el$21);
    _$insert(_el$20, () => pairs().length, _el$28);
    _$insert(_el$20, _$createComponent(Show, {
      get when() {
        return counts().ok + counts().error > 0;
      },
      get children() {
        var _el$23 = _tmpl$2(),
          _el$24 = _el$23.firstChild,
          _el$25 = _el$24.firstChild;
        _$insert(_el$24, () => counts().ok, null);
        _$insert(_el$23, _$createComponent(Show, {
          get when() {
            return counts().error > 0;
          },
          get children() {
            var _el$26 = _tmpl$(),
              _el$27 = _el$26.firstChild;
            _$insert(_el$26, () => counts().error, null);
            return _el$26;
          }
        }), null);
        return _el$23;
      }
    }), null);
    _$insert(_el$19, _$createComponent(Show, {
      get when() {
        return pairs().length > 0;
      },
      get fallback() {
        return (() => {
          var _el$42 = _tmpl$6();
          _$insert(_el$42, () => tr('bulk.NoPairs'));
          return _el$42;
        })();
      },
      get children() {
        return _$createComponent(For, {
          get each() {
            return pairs();
          },
          children: pair => (() => {
            var _el$43 = _tmpl$9(),
              _el$44 = _el$43.firstChild,
              _el$45 = _el$44.nextSibling;
            _$insert(_el$44, () => [pair.meta_name, ...pair.photos.map(file => file.name), ...pair.extras.map(file => file.name)].join(' + '));
            _$insert(_el$45, _$createComponent(Show, {
              get when() {
                var _result2;
                return ((_result2 = result(pair.key)) === null || _result2 === void 0 ? void 0 : _result2.status) === 'running';
              },
              children: "\u23F3"
            }), null);
            _$insert(_el$45, _$createComponent(Show, {
              get when() {
                var _result3;
                return ((_result3 = result(pair.key)) === null || _result3 === void 0 ? void 0 : _result3.status) === 'ok';
              },
              get children() {
                return ["\u2713 ", _$memo(() => result(pair.key).device_id || '—'), _$createComponent(Show, {
                  get when() {
                    return result(pair.key).warnings > 0;
                  },
                  get children() {
                    var _el$46 = _tmpl$7(),
                      _el$47 = _el$46.firstChild;
                    _$insert(_el$46, () => result(pair.key).warnings, null);
                    return _el$46;
                  }
                })];
              }
            }), null);
            _$insert(_el$45, _$createComponent(Show, {
              get when() {
                var _result4;
                return ((_result4 = result(pair.key)) === null || _result4 === void 0 ? void 0 : _result4.status) === 'exists';
              },
              get children() {
                return ["= ", _$memo(() => tr('bulk.Exists')), ": ", _$memo(() => result(pair.key).id)];
              }
            }), null);
            _$insert(_el$43, _$createComponent(Show, {
              get when() {
                var _result5;
                return ((_result5 = result(pair.key)) === null || _result5 === void 0 ? void 0 : _result5.status) === 'error';
              },
              get children() {
                var _el$48 = _tmpl$8(),
                  _el$49 = _el$48.firstChild;
                _$insert(_el$48, () => result(pair.key).error, null);
                return _el$48;
              }
            }), null);
            _$effect(_p$ => {
              var _result6, _result7, _result8;
              var _v$5 = !!(((_result6 = result(pair.key)) === null || _result6 === void 0 ? void 0 : _result6.status) === 'ok'),
                _v$6 = !!(((_result7 = result(pair.key)) === null || _result7 === void 0 ? void 0 : _result7.status) === 'error'),
                _v$7 = !!(((_result8 = result(pair.key)) === null || _result8 === void 0 ? void 0 : _result8.status) === 'exists');
              _v$5 !== _p$.e && _el$43.classList.toggle("ok", _p$.e = _v$5);
              _v$6 !== _p$.t && _el$43.classList.toggle("err", _p$.t = _v$6);
              _v$7 !== _p$.a && _el$43.classList.toggle("exists", _p$.a = _v$7);
              return _p$;
            }, {
              e: undefined,
              t: undefined,
              a: undefined
            });
            return _el$43;
          })()
        });
      }
    }), null);
    _$insert(_el$19, _$createComponent(Show, {
      get when() {
        return unmatched().length > 0;
      },
      get children() {
        return [(() => {
          var _el$29 = _tmpl$3(),
            _el$30 = _el$29.firstChild,
            _el$32 = _el$30.nextSibling,
            _el$31 = _el$32.nextSibling;
          _$insert(_el$29, () => tr('bulk.Unmatched'), _el$30);
          _$insert(_el$29, () => unmatched().length, _el$32);
          return _el$29;
        })(), _$createComponent(For, {
          get each() {
            return unmatched();
          },
          children: entry => (() => {
            var _el$50 = _tmpl$0(),
              _el$51 = _el$50.firstChild,
              _el$52 = _el$51.nextSibling;
            _$insert(_el$51, () => entry.name);
            _$insert(_el$52, () => entry.missing);
            return _el$50;
          })()
        })];
      }
    }), null);
    _el$35.$$click = () => m.closeBulk();
    _$insert(_el$35, () => t('form.cancel'));
    _el$37.$$click = () => m.runBulk();
    _$insert(_el$37, () => tr('bulk.ImportAll'), _el$38);
    _$insert(_el$37, () => pairs().filter(pair => {
      var _result9;
      return !/^(ok|exists)$/.test((_result9 = result(pair.key)) === null || _result9 === void 0 ? void 0 : _result9.status);
    }).length, _el$40);
    _$effect(_p$ => {
      var _v$ = tr('wizard.LocalityPlaceholder'),
        _v$2 = b().running,
        _v$3 = b().running,
        _v$4 = !importable() || b().running;
      _v$ !== _p$.e && _$setAttribute(_el$10, "placeholder", _p$.e = _v$);
      _v$2 !== _p$.t && (_el$10.disabled = _p$.t = _v$2);
      _v$3 !== _p$.a && (_el$35.disabled = _p$.a = _v$3);
      _v$4 !== _p$.o && (_el$37.disabled = _p$.o = _v$4);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined
    });
    _$effect(() => _el$10.value = b().shared.locality);
    return _el$;
  })();
}
_$delegateEvents(["click", "input"]);